import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Colors from "../../components/ui/Colors";
import { Button, DialogContent, Typography } from "@mui/material";
import Card from '@mui/material/Card';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import NumberFormat from "react-number-format";
import { getProductBatch, addNewEntryToManualInventory } from "../../utilityFunctions/WarehouseUtil";
import { QrReader } from 'react-qr-reader';
import swal from 'sweetalert';
import { PuffLoader } from "react-spinners";
import { css } from "@emotion/react";
import { useHistory, useLocation } from "react-router-dom";

const cssLoader = css`
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const dateOptions = {
    day: "numeric",
    month: "numeric",
    year: "numeric",
};

const checkpointObject = {
    username: "",
    id: "",
};

const constraints = {
    facingMode: "environment",
};

const manualEntryRequest = {
    manualProductAmount: 0,
    comment: "",
    batchId: "",
    manualInventoryId: "",
};

let productResponse;

export default function ManualInventoryEntry(props) {
    
    const { loginUser } = props;
    const location = useLocation();
    let history = useHistory();
    const [loading, setLoading] = React.useState(false);
    const [manualInventoryId, setManualInventoryId] = React.useState("");

    React.useEffect(() => {
        if (location.state && location.state.manualInventoryId) {
            setManualInventoryId(location.state.manualInventoryId);
            manualEntryRequest.manualInventoryId = location.state.manualInventoryId;
        } else {
            // No inventory ID provided, ask for one
            swal({
                title: "Ingrese ID de Inventario",
                text: "Por favor ingrese el ID del inventario manual",
                content: "input",
                buttons: "Confirmar"
            }).then((value) => {
                if (value) {
                    setManualInventoryId(value);
                    manualEntryRequest.manualInventoryId = value;
                } else {
                    history.push("/warehouse");
                }
            });
        }

        checkpointObject.id = "";
        checkpointObject.username = "";
    }, []);

    const [description, setDescription] = React.useState("");
    const [amount, setAmount] = React.useState("");
    const [batchId, setBatchId] = React.useState("");
    const [batchCode, setBatchCode] = React.useState("");
    const [expirationDate, setExpirationDate] = React.useState("");
    const [manualAmount, setManualAmount] = React.useState("");
    const [comment, setComment] = React.useState("");

    const [disableButton, setDisableButton] = React.useState(true);
    const [qrScanner, setQrScanner] = React.useState(false);

    const openQrScanner = () => {
        setQrScanner(true);
        setDisableButton(true);
    };

    const closeQrScanner = () => {
        setQrScanner(false);
    };

    const handleScan = async (data) => {
        if (data) {
            closeQrScanner();

            const jsonData = JSON.parse(data.text);

            if (!jsonData.label) {
                return;
            }

            checkpointObject.id = jsonData.label;
            checkpointObject.username = loginUser.accountId;

            setLoading(true);
            productResponse = await getProductBatch(checkpointObject, loginUser.jwtToken);
            setLoading(false);

            if (!productResponse) {
                return;
            }

            setDescription(productResponse.warehouseProduct.description);
            setAmount(productResponse.productAmount);
            setBatchCode(productResponse.batchCode);
            setBatchId(productResponse.id);
            manualEntryRequest.batchId = productResponse.id;
            setExpirationDate(productResponse.expirationDate);
            setDisableButton(false);
        }
    };

    React.useEffect(() => {
        closeQrScanner();
        setDisableButton(false);
    }, [description]);
    
    const handleError = (error) => {
        console.error('Error reading QR code:', error);
    };

    const [qrInput, setQrInput] = React.useState("");

    const qrInputChange = async (e) => {
        const value = e.target.value.replace(/\D/g, '');
        setQrInput(value);
        checkpointObject.id = value;
    };

    const qrInputSubmit = async() => {
        checkpointObject.username = loginUser.accountId;
        
        setLoading(true);
        productResponse = await getProductBatch(checkpointObject, loginUser.jwtToken);
        setLoading(false);

        if (!productResponse) {
            swal({
                title: "Código errado",
                text: "El código ingresado es incorrecto. Por favor verificar",
                icon: "error",
                buttons: "OK"
            });
            return;
        }

        setDescription(productResponse.warehouseProduct.description);
        setAmount(productResponse.productAmount);
        setBatchCode(productResponse.batchCode);
        setBatchId(productResponse.id);
        manualEntryRequest.batchId = productResponse.id;
        setExpirationDate(productResponse.expirationDate);
        setDisableButton(false);
    };

    const handleCommentChange = (e) => {
        setComment(e.target.value);
        manualEntryRequest.comment = e.target.value;
    };

    const handleManualAmountChange = (values) => {
        setManualAmount(values.floatValue);
        manualEntryRequest.manualProductAmount = values.floatValue;
    };

    const submitManualEntry = async () => {
        if (!manualEntryRequest.batchId) {
            swal({
                title: "Error",
                text: "Debe escanear o buscar una estiba primero",
                icon: "error",
                buttons: "OK"
            });
            return;
        }

        if (!manualEntryRequest.manualProductAmount) {
            swal({
                title: "Error",
                text: "Debe ingresar una cantidad manual",
                icon: "error",
                buttons: "OK"
            });
            return;
        }

        setLoading(true);
        const entryResponse = await addNewEntryToManualInventory(manualEntryRequest, loginUser.jwtToken);
        setLoading(false);

        if (!entryResponse) {
            swal({
                title: "Error",
                text: "No se pudo agregar la entrada. Por favor intente de nuevo.",
                icon: "error",
                buttons: "OK"
            });
            return;
        }

        if (entryResponse === "duplicated") {
            swal({
                title: "Error",
                text: "La estiba ya existe en el inventario.",
                icon: "error",
                buttons: "OK"
            });
            return;
        }
        
        // Calculate difference for display
        const difference = manualEntryRequest.manualProductAmount - amount;
        const differenceText = difference === 0 
            ? "No hay diferencia entre las cantidades" 
            : `Diferencia: ${difference > 0 ? '+' : ''}${difference}`;

        swal({
            title: "Entrada Agregada",
            text: `La entrada se ha agregado exitosamente. ${differenceText}`,
            icon: "success",
            buttons: "OK"
        });

        clearForm();
    };

    const clearForm = () => {
        setDescription("");
        setAmount("");
        setBatchCode("");
        setBatchId("");
        setExpirationDate("");
        setManualAmount("");
        setComment("");
        setQrInput("");
        manualEntryRequest.batchId = "";
        manualEntryRequest.manualProductAmount = 0;
        manualEntryRequest.comment = "";
        checkpointObject.id = "";
        checkpointObject.username = "";
    };

    return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%", backgroundColor: "#ededed" }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: { xs: "start", sm: "center", md: "center" },
                    width: "90%",
                    height: "100%",
                    textAlign: "center",
                }}
            >
                {loading ? <PuffLoader size={100} color={Colors.secondary} css={cssLoader} /> : 
                <Grid container sx={{ display: "flex", justifyContent: "center" }}>
                    <Grid item xs={12} sm={12} md={12} sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                        <Card sx={{ maxWidth: "400px", minWidth: { xs: "90%", sm: "60%", md: "300px" }, minHeight: "200px", borderRadius: "15px", marginTop: { xs: "20%", sm: "0%", md: "2rem" }, marginBottom: { xs: "1rem", sm: "1rem", md: "1rem" } }}> 
                            <Grid container spacing={1} sx={{ display: "flex", justifyContent: { xs: "center", sm: "center" }, alignItems: { xs: "center", sm: "center", md: "center" }, width: "100%", marginLeft: "1%" }}>
                                <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "center", marginTop: "1.3rem" }}>
                                    <Typography variant="h6">Inventario Manual #{manualInventoryId}</Typography>
                                </Grid>

                                {batchId &&
                                    <>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "start", alignItems: "center", marginTop: "1.3rem", marginLeft: "10%" }}>
                                        <Typography sx={{ color: "gray", fontSize: "0.6rem" }}>Número Estiba</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "start", alignItems: "center", marginLeft: "10%" }}>
                                        <Typography variant="body1">{`${batchId}`}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} sx={{ marginBottom: "0.6rem", marginLeft: "10%" }}>
                                        <Divider sx={{ width: "90%" }} />
                                    </Grid>
                                    </>
                                }
                                {description &&
                                    <>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "start", alignItems: "center", marginTop: "0.1rem", marginLeft: "10%" }}>
                                        <Typography sx={{ color: "gray", fontSize: "0.6rem" }}>Descripción</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "start", alignItems: "center", marginLeft: "10%" }}>
                                        <Typography variant="body1">{`${description}`}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} sx={{ marginBottom: "0.6rem", marginLeft: "10%" }}>
                                        <Divider sx={{ width: "90%" }} />
                                    </Grid>
                                    </>
                                }
                                {amount &&
                                    <>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "start", alignItems: "center", marginLeft: "10%" }}>
                                        <Typography sx={{ color: "gray", fontSize: "0.6rem" }}>Cantidad Sistema</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "start", alignItems: "center", marginLeft: "10%" }}>
                                        <Typography variant="body2">{`${new Intl.NumberFormat('es-CO').format(amount)}`}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} sx={{ marginLeft: "10%" }}>
                                        <Divider sx={{ width: "90%" }} />
                                    </Grid>
                                    </>
                                }
                                {batchCode &&
                                    <>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "start", alignItems: "center", marginTop: "0.1rem", marginLeft: "10%" }}>
                                        <Typography sx={{ color: "gray", fontSize: "0.6rem" }}>Lote</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "start", alignItems: "center", marginLeft: "10%" }}>
                                        <Typography variant="body1">{`${batchCode}`}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} sx={{ marginBottom: "0.6rem", marginLeft: "10%" }}>
                                        <Divider sx={{ width: "90%" }} />
                                    </Grid>
                                    </>
                                }
                                {expirationDate &&
                                    <>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "start", alignItems: "center", marginTop: "0.1rem", marginLeft: "10%" }}>
                                        <Typography sx={{ color: "gray", fontSize: "0.6rem" }}>Fecha Vencimiento</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "start", alignItems: "center", marginLeft: "10%" }}>
                                        <Typography variant="body1">{`${new Intl.DateTimeFormat('es-CO', dateOptions).format(new Date(expirationDate))}`}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} sx={{ marginBottom: "0.6rem", marginLeft: "10%" }}>
                                        <Divider sx={{ width: "90%" }} />
                                    </Grid>
                                    </>
                                }
                                {/* Manual Amount Input */}
                                {batchId &&
                                    <>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "0.2rem" }}>
                                        <NumberFormat
                                            sx={{ width: "80%" }}
                                            variant="standard"
                                            fullWidth={true}
                                            id="manualAmount"
                                            name="manualAmount"
                                            customInput={TextField}
                                            thousandSeparator={'.'}
                                            decimalSeparator={','}
                                            label={<Typography variant="body2">Cantidad Manual</Typography>}
                                            value={manualAmount}
                                            onValueChange={handleManualAmountChange}
                                            autoComplete="off"
                                            isAllowed={(values) => {
                                                const { floatValue, value } = values;
                                                return (floatValue === undefined && !value.includes('-')) || floatValue >= 0;
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "0.6rem" }}>
                                        <TextField
                                            sx={{ width: "80%" }}
                                            variant="outlined"
                                            fullWidth={true}
                                            id="comment"
                                            name="comment"
                                            label={<Typography variant="body2">Comentario</Typography>}
                                            value={comment}
                                            onChange={handleCommentChange}
                                            autoComplete="off"
                                            multiline
                                            rows={2}
                                        />
                                    </Grid>
                                    </>
                                }

                                {!description &&
                                    <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "center", marginTop: "4.5rem", marginBottom: "1rem" }}>
                                        <Button onClick={openQrScanner} variant="contained" sx={{ backgroundColor: Colors.primary }}>
                                            Escanear
                                        </Button>
                                    </Grid>
                                }
                                {description && (manualAmount || manualAmount===0) &&
                                    <>
                                    <Grid item xs={6} sm={6} md={6} sx={{ display: "flex", justifyContent: "end", marginTop: "1.8rem", marginBottom: "1rem" }}>
                                        <Button onClick={openQrScanner} variant="contained" sx={{ backgroundColor: Colors.primary }}>
                                            Escanear
                                        </Button>
                                    </Grid>
                                    
                                    <Grid item xs={6} sm={6} md={6} sx={{ display: "flex", justifyContent: "start", marginTop: "1.8rem", marginBottom: "1rem" }}>
                                        <Button disabled={disableButton} onClick={submitManualEntry} variant="contained" sx={{ backgroundColor: Colors.primary }}>
                                            Guardar
                                        </Button>
                                    </Grid>
                                    </>
                                }
                                <Grid item xs={12} sm={12} md={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "0.2rem" }}>
                                    <TextField
                                        sx={{ width: "80%" }}
                                        variant="standard"
                                        fullWidth={true}
                                        id="qrInput"
                                        name="qrInput"
                                        label={<Typography variant="body2">Código Estiba</Typography>}
                                        value={qrInput}
                                        onChange={(e) => qrInputChange(e)}
                                        autoComplete="off"
                                    />
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} sx={{ display: "flex", justifyContent: "center", marginTop: "1rem", marginBottom: "1rem" }}>
                                    <Button onClick={() => history.push("/warehouse/manual-inventory-list")} variant="contained" sx={{ backgroundColor: Colors.primary }}>
                                        Atrás
                                    </Button>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} sx={{ display: "flex", justifyContent: "center", marginTop: "1rem", marginBottom: "1rem" }}>
                                    <Button onClick={qrInputSubmit} variant="contained" sx={{ backgroundColor: Colors.primary }}>
                                        Buscar
                                    </Button>
                                </Grid>
                            </Grid>
                        </Card>
                    </Grid>
                </Grid>
                }

                <Dialog open={qrScanner} onClose={closeQrScanner}
                    sx={{
                        "& .MuiDialog-container": {
                            "& .MuiPaper-root": {
                                width: { xs: "80%", sm: "80%", md: "60%" },
                            },
                        },
                    }}
                > 
                    <Box sx={{ width: "100%", minWidth: "20rem", minHeight: "20rem" }}>
                        <QrReader
                            delay={300}
                            onError={handleError}
                            onResult={handleScan}
                            style={{ width: '100%', height: "100%" }}
                            containerStyle={{ width: '100%' }}
                            videoContainerStyle={{ width: '100%' }}
                            videoStyle={{ width: '100%' }}
                            constraints={constraints}
                        />
                    </Box>
                    <DialogActions>
                        <Button onClick={closeQrScanner} variant="contained" sx={{ backgroundColor: Colors.primary }}>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </Box>
    );
} 